import React from "react";
import { classNames } from "@/lib/util";

export type StatusDotProps = {
    cx?: number;
    cy?: number;
    r: number;
    fill: string;
    opacity?: number;
    /** When true, wraps the circle in an SVG for use outside an existing SVG context. */
    standaloneSvg?: boolean;
    className?: string;
} & Omit<React.SVGProps<SVGCircleElement>, "cx" | "cy" | "r" | "fill" | "opacity" | "className">;

const StatusDot = ({
    cx,
    cy,
    r,
    fill,
    opacity = 1,
    standaloneSvg = true,
    className,
    ...circleProps
}: StatusDotProps) => {
    const circleCx = cx ?? r / 2;
    const circleCy = cy ?? r / 2;
    const circleR = standaloneSvg ? r / 2 : r;
    const strokeWidth = standaloneSvg ? 4 : 12;

    const circle = (
        <circle
            className="cursor-default"
            cx={circleCx}
            cy={circleCy}
            r={circleR}
            fill={fill}
            // Increase the hit radius for easier mouse hover detection
            stroke="transparent"
            strokeWidth={strokeWidth}
            opacity={opacity}
            {...circleProps}
        />
    );

    if (standaloneSvg) {
        return (
            <svg
                width={r}
                height={r}
                viewBox={`0 0 ${r} ${r}`}
                className={classNames("line-status-inline", className)}
                aria-hidden
            >
                {circle}
            </svg>
        );
    }

    return circle;
};

export default StatusDot;
